import { Component, EventEmitter, Output, ViewChild, ElementRef, HostListener, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ImagePreviewComponent } from '../image-preview/image-preview.component';
import { base64ToBlob } from 'src/app/shared/utils/base64ToBlob';
import { autoDownloadFile } from 'src/app/shared/utils/autoDownloadFile';

@Component({
    selector: 'app-image-upload',
    templateUrl: './image-upload.component.html',
    styleUrls: ['./image-upload.component.scss'],
})
export class ImageUploadComponent {
    @Output() imageChanged = new EventEmitter<File | null>();
    @ViewChild('fileInput') fileInput: ElementRef<HTMLInputElement>;
    @Input() label: string = '';
    @Input() imageSrcInput: string = ''; //Busca o caminho da imagem através do form control caso readonly
    @Input() readonly: boolean = false;
    @Input() selectedFileInput; //Busca os valores do anexo através do form control caso readonly
    selectedFile: File | null = null;
    imageSrc: string | ArrayBuffer | null = null;
    isDragging = false;


    constructor(private dialog: MatDialog) { }

    triggerFileInput(): void {
        this.fileInput.nativeElement.click();
    }

    download() {
        let blob;
        if (!this.readonly) {
            blob = base64ToBlob(this.imageSrc.toString().split(',')[1], this.selectedFile.type)
            autoDownloadFile(blob, this.selectedFile.name)
        } else {
            blob = base64ToBlob(this.imageSrcInput.toString().split(',')[1], this.selectedFileInput.type)
            autoDownloadFile(blob, this.selectedFileInput.filename)
        }
    }


    onFileSelected(event: Event): void {
        // Solicita permissão para acessar a câmera antes de abrir o seletor de arquivos
        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
            navigator.mediaDevices.getUserMedia({ video: true })
                .then(stream => {
                    console.log('Permissão concedida para acessar a câmera');
                    // Selecionar arquivo após a permissão
                    const input = event.target as HTMLInputElement;
                    if (input.files && input.files.length > 0) {
                        this.handleFile(input.files[0]);
                    }
                })
                .catch(err => {
                    alert('Permissão para acessar a câmera foi negada.');
                });
        } else {
            // Se não houver suporte à API de mediaDevices, apenas deixe o usuário escolher o arquivo
            const input = event.target as HTMLInputElement;
            if (input.files && input.files.length > 0) {
                this.handleFile(input.files[0]);
            }
        }
    }


    onFileDropped(event: DragEvent): void {
        event.preventDefault();
        event.stopPropagation();
        this.isDragging = false;

        if (event.dataTransfer?.files && event.dataTransfer.files.length > 0) {
            this.handleFile(event.dataTransfer.files[0]);
        }
    }

    handleFile(file: File): void {
        this.selectedFile = file;
        const reader = new FileReader();
        reader.onload = () => {
            this.imageSrc = reader.result;
            this.imageChanged.emit(this.selectedFile);
        };
        reader.readAsDataURL(this.selectedFile);
    }

    removeImage(event: Event): void {
        event.stopPropagation();
        this.selectedFile = null;
        this.imageSrc = null;
        this.imageChanged.emit(null);

        if (this.fileInput && this.fileInput.nativeElement) {
            this.fileInput.nativeElement.value = '';
        }
    }

    @HostListener('dragover', ['$event'])
    onDragOver(event: DragEvent): void {
        event.preventDefault();
        event.stopPropagation();
        this.isDragging = true;
    }

    @HostListener('dragleave', ['$event'])
    onDragLeave(event: DragEvent): void {
        event.preventDefault();
        event.stopPropagation();
        this.isDragging = false;
    }

    @HostListener('drop', ['$event'])
    onDrop(event: DragEvent): void {
        this.onFileDropped(event);
    }


    viewImage(): void {
        let imgSrc;

        if (!this.readonly) {
            imgSrc = this.imageSrc
        } else {
            imgSrc = this.imageSrcInput
        }


        this.dialog.open(ImagePreviewComponent, {
            data: {
                imgSrc
            },
            width: '80%',
            maxHeight: '100vh'
        });
    }
}